import React from 'react';
import { Link } from 'react-router-dom';
import './marketing.css';

export default function ThankYouPage() {
  return (
    <div className="mkt-pay">
      <div className="mkt-thanks" style={{ maxWidth: 720, textAlign: 'left' }}>
        <h1>Thank you</h1>
        <p>
          Thank you for choosing Canvas Memories! We’re absolutely delighted to have you with us.
          Once your payment has been received and verified, you’ll receive a service activation email from us shortly.
          We can’t wait to get started!
        </p>
        <Link className="mkt-btn" to="/" style={{ display: 'inline-block', textDecoration: 'none' }}>Back to home</Link>
      </div>
    </div>
  );
}
